import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy px-5 py-8 sm:py-10" data-id="element-68" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-2xl text-center" data-id="element-69" data-mp="3gfsoch60l2p3">
        <p className="font-display text-base font-semibold text-gold" data-id="element-70" data-mp="3ghc3u5juj9pt">THE COMPLETE ART YEAR™</p>
        <p className="mt-2 text-xs leading-relaxed text-white/60" data-id="element-71" data-mp="32pp5m06cfr4e">
          Digital Visual Arts Teaching Resources · No Physical Shipping
        </p>
        <p className="mt-2 text-xs leading-relaxed text-white/60" data-id="element-72" data-mp="3ueih5klswg7n">
          One-Time Payment · No Subscription · Lifetime Access
        </p>
        <p className="mt-4 text-xs leading-relaxed text-white/45" data-id="element-73" data-mp="37xx4ku5y8k4">
          Individual educator license for use by the purchasing teacher with their own classes.
          Redistribution of the complete digital files, full-file sharing, resale, or modification
          for resale is not permitted.
        </p>
        <p className="mt-3 text-xs leading-relaxed text-white/45" data-id="element-74" data-mp="2a19uhoqc1syc">
          The resources are educational support materials designed to help teachers plan and deliver
          Visual Arts instruction. Teachers remain responsible for adapting activities, materials and
          expectations to their students, local curriculum and school requirements.
        </p>
        <p className="mt-3 text-xs leading-relaxed text-white/45" data-id="element-75" data-mp="3v8hrk7zwj2sl">
          THE COMPLETE ART YEAR™ supports teaching and learning but does not replace teacher judgment
          or guarantee specific student outcomes.
        </p>
        <p className="mt-4 text-xs text-white/40" data-id="element-76" data-mp="80xhs2coepgg">© 2026 The complete ART year . All Rights Reserved.</p>
      </div>
    </footer>;
}